<template>
  <div class="header-panel">
    <slot></slot>
  </div>
</template>

<script src="./HeaderPanel.js"></script>

<style lang="scss" src="./HeaderPanel.scss"></style>
